<template>
  <div>
    <h3 class="page-header">Colours</h3>
      <div class="pwave-color-container">
        <div class="pwave-color-item">
          <div class="color-pallete bg-primary"></div>
          <div class="text-center pt-10">
            <p>#f2a727</p>
            <p>primary</p>
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-accent"></div>
          <div class="text-center pt-10">
            <p>#ffc858</p>
            <p>accent</p>
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-secondary"></div>
          <div class="text-center pt-10">
            <p>#f25f00</p>
            <p>secondary</p>
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground"></div>
          <div class="text-center pt-10">
            <p>#272727</p>
            <p>foreground</p>
          </div>
        </div>
      </div>

      <h4>Shades of grey</h4>
      <div class="pwave-color-container">
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground"></div>
          <div class="text-center pt-10">
            <p>#272727</p>
            <p>foreground</p>
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground--lighten"></div>
          <div class="text-center pt-10">
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground--lighten-2"></div>
          <div class="text-center pt-10">
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground--lighten-3"></div>
          <div class="text-center pt-10">
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-foreground--lighten-4"></div>
          <div class="text-center pt-10">
          </div>
        </div>
        <div class="pwave-color-item">
          <div class="color-pallete bg-white"></div>
          <div class="text-center pt-10">
            <p>#fdfdfd</p>
            <p>white</p>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/assets/components/PwColours.vue